import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Opportunity} from '../models/opportunity/opportunity.model';
import {Employee} from '../models/employee/employee.model';
import {QuoteWrapper} from '../models/quote/quote-wrapper';
import {Page} from '../utils/page';
import {EnumOpportunityStatus} from '../models/enum/enum-opportunity-status';
import {deepCloneWithPrototype} from "../utils/clone-utils";

@Injectable()
export abstract class OpportunityV3ManagerService {

    constructor(
        protected httpClient: HttpClient) {
    }

    public abstract saveOpportunity(opportunity: Opportunity): Observable<Opportunity>;

    public abstract updateOpportunityMainQuote(mainQuoteId: string, opportunityId: number | string): Observable<Opportunity>;

    public abstract updateOpportunityStatus(status: string, opportunityId: number | string): Observable<Opportunity>;

    public abstract getOpportunitiesWithQuotes(pageable: Map<string, string>, filters: Map<string, string>) : Observable<Page<Opportunity>> ;

    public abstract watchOpportunityChanges(): Observable<any>;

    public getAvailableOpportunitiesStatus(opportunity: Opportunity) {
        const status = opportunity.status;
        switch(status) {
            case EnumOpportunityStatus.IN_PROGRESS:
                return [EnumOpportunityStatus.IN_PROGRESS, EnumOpportunityStatus.CANCELED, EnumOpportunityStatus.LOST, EnumOpportunityStatus.WON];
            case EnumOpportunityStatus.WON:
                return [EnumOpportunityStatus.WON, EnumOpportunityStatus.CANCELED, EnumOpportunityStatus.LOST, EnumOpportunityStatus.IN_PROGRESS];
            case EnumOpportunityStatus.CANCELED:
                return [EnumOpportunityStatus.CANCELED, EnumOpportunityStatus.IN_PROGRESS];
            case EnumOpportunityStatus.LOST:
                return opportunity.salesFileStatus !== null ? [EnumOpportunityStatus.LOST] : [EnumOpportunityStatus.LOST, EnumOpportunityStatus.IN_PROGRESS];
        }
    }

    public mapOpportunityFromQuoteWrapper(wrapper: QuoteWrapper, employee: Employee) {
        let opportunity: Opportunity = new Opportunity();
        opportunity.client = wrapper.clientInfos;
        let emp = deepCloneWithPrototype(employee, Employee);
        emp.regionCode = wrapper.regionCode;
        emp.regionLabel = wrapper.regionLabel;
        emp.teamCode = wrapper.teamCode;
        emp.teamLabel = wrapper.teamLabel;
        emp.role = wrapper.employeeRole.eForceRole;
        emp.speciality = wrapper.speciality;
        opportunity.employee = emp;
        opportunity.label = wrapper.opportunityLabel;
        opportunity.status = wrapper.opportunityStatus;
        opportunity.eforceOpportunityId = wrapper.eforceOpportunityId;
        opportunity.creationDate = wrapper.opportunityCreationDate;
        opportunity.salesFileStatus = wrapper.opportunitySalesFileStatus;
        opportunity.opportunityType = wrapper.opportunityType;
        opportunity.offlineId = wrapper.opportunityOfflineId;

        return opportunity;
    }



}
